import { useState } from 'react';

import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

import { OrderMailModal } from '../tableActions/MailModal';

export const ArticleOrderExpired = ({ offer, notAnsweredAuthor }) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Button
        block
        type="primary"
        className="gx-mt-3 gx-mb-0 gx-text-uppercase"
        onClick={() => setModalVisible(true)}
      >
        <FormattedMessage id="appModule.sendMail" />
      </Button>

      {notAnsweredAuthor && (
        <OrderMailModal
          offer={offer}
          open={modalVisible}
          close={() => setModalVisible(false)}
        />
      )}
    </>
  );
};
